module.exports = __webpack_public_path__ + "static/media/21.d3ccb301.jpg";